import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";

export const invitations = (api: API) => ({
  get(
    success: (data: OpenAPI.GET<"/invitations">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("GET", "/invitations", null, success, fail);
  },
  getAccepted(
    success: (data: OpenAPI.GET<"/invitations">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      "/invitations?accepted=true",
      null,
      success,
      fail,
    );
  },
  findByToken(
    token: string,
    success: (
      data: OpenAPI.GET<"/invitations/find_by_token">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/invitations/find_by_token?token=${token}`,
      null,
      success,
      fail,
    );
  },
  getForType(
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.GET<"/invitations/{for_type}/{for_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/invitations/${forType}/${forId}`,
      null,
      success,
      fail,
    );
  },
  create(
    data: OpenAPI.POST<"/invitations">["requestBody"],
    success: (data: OpenAPI.POST<"/invitations">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("POST", "/invitations", data, success, fail);
  },
  createBulk(
    data: OpenAPI.POST<"/invitations/bulk">["requestBody"],
    success: (data: OpenAPI.POST<"/invitations/bulk">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("POST", "/invitations/bulk", data, success, fail);
  },
  remove(
    id: string,
    success: (data: OpenAPI.DELETE<"/invitations/{id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/invitations/${id}`,
      null,
      success,
      fail,
    );
  },
  accept(
    id: string,
    success: (
      data: OpenAPI.POST<"/invitations/{id}/accept">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/invitations/${id}/accept`,
      { targetUser: null },
      success,
      fail,
    );
  },
  acceptToken(
    token: string,
    success: (
      data: OpenAPI.POST<"/invitations/accept_token">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/invitations/accept_token",
      { token },
      success,
      fail,
    );
  },
  reject(
    id: string,
    success: (
      data: OpenAPI.POST<"/invitations/{id}/reject">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/invitations/${id}/reject`,
      null,
      success,
      fail,
    );
  },
  createLink(
    id: string,
    success: (data: OpenAPI.POST<"/invitations/{id}/link">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/invitations/${id}/link`,
      null,
      success,
      fail,
    );
  },
  resend(
    id: string,
    success: (
      data: OpenAPI.POST<"/invitations/{id}/resend">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/invitations/${id}/resend`,
      null,
      success,
      fail,
    );
  },
});
